import { Button } from '@/components/form/baseInputs/Button';
import { PlusIcon } from '@/components/icons/PlusIcon';
import { useModalState } from '@/hooks/useModalState';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

import { BaselineIncomeAndExpensesFormShape } from '../GiftDesignerBasicInformationForm.types';
import { BaselineIncomeAndExpensesModal } from './BaselineIncomeAndExpensesModal/BaselineIncomeAndExpensesModal';

interface AddNewIncomeOrExpenseButtonProps {
  isLoadingForm: boolean;
  onSubmitSuccess: (formData: BaselineIncomeAndExpensesFormShape) => void;
}

export function AddNewIncomeOrExpenseButton({
  isLoadingForm,
  onSubmitSuccess,
}: AddNewIncomeOrExpenseButtonProps) {
  const canEdit = useCanEditHouseholdData();
  const [{ isModalOpen }, { openModal, closeModal }] = useModalState();

  if (!canEdit) {
    return null;
  }

  return (
    <>
      <BaselineIncomeAndExpensesModal
        incomeData={null}
        isOpen={isModalOpen}
        onClose={() => {
          closeModal();
        }}
        onSubmitSuccess={(formData) => {
          onSubmitSuccess(formData);
          closeModal();
        }}
      />

      <Button
        startIcon={PlusIcon}
        variant="secondary"
        size="sm"
        onClick={() => {
          openModal();
        }}
        loading={isLoadingForm}
      >
        Add cash flow
      </Button>
    </>
  );
}
